import { useState } from "react";
import { hasCargo, getCargoUnits, tradeGoodInContract, formatNumber } from "../../utils/helpers";
import Button, { ButtonGroup } from "../common/Button";
import Flow from "../common/Flow";
import Modal from "../common/Modal";
import Table, { TableActions } from "../common/Table";
import { TabContent, TabItem, Tabs } from "../common/Tabs";
import Typography from "../common/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKipSign, faMinus, faPlus } from "@fortawesome/pro-light-svg-icons";

function MarketplaceModal({ store }) {
  const [tab, setTab] = useState('tradeGoods');
  const [amount, setAmount] = useState(0);
  const contracts = store.state.contracts;
  const imports = store.state.marketplace.imports;
  const exports = store.state.marketplace.exports;
  const exchanges = store.state.marketplace.exchange;
  const transactions = store.state.marketplace.transactions;
  const tradeGoods = store.state.marketplace.tradeGoods;
  const cargo = store.getSelectedShip() ? store.getSelectedShip().cargo.inventory : [];

  const purchase = (symbol) => {
    store.purchase(symbol, amount);
    setAmount(0);
  };

  const sell = (symbol) => {
    store.sell(symbol, amount);
    setAmount(0);
  };

  return (
    <Modal store={store} $padding>
      <Flow $space={6}>
        <Typography as="h1" fontSize="2xl">Marketplace</Typography>
        <Tabs>
          <TabItem onClick={() => setTab('tradeGoods')} $active={tab == 'tradeGoods'}>Trade goods</TabItem>
          <TabItem onClick={() => setTab('imports')} $active={tab == 'imports'}>Imports</TabItem>
          <TabItem onClick={() => setTab('exports')} $active={tab == 'exports'}>Exports</TabItem>
          <TabItem onClick={() => setTab('exchange')} $active={tab == 'exchange'}>Exchange</TabItem>
          <TabItem onClick={() => setTab('transactions')} $active={tab == 'transactions'}>Transactions</TabItem>
        </Tabs>
        {tab == 'imports' && (
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>Name</th>
                  <th>Descripion</th>
                </tr>
              </thead>
              <tbody>
                {imports && imports.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.symbol}</td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        )}
        {tab == 'exports' && (
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>Name</th>
                  <th>Descripion</th>
                </tr>
              </thead>
              <tbody>
                {exports && exports.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.symbol}</td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        )}
        {tab == 'exchange' && (
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {exchanges && exchanges.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        )}
        {tab == 'transactions' && (
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Waypoint</th>
                  <th>Ship</th>
                  <th>Trad</th>
                </tr>
              </thead>
              <tbody>
                {transactions && transactions.map((transaction, idx) => (
                  <tr>
                    <td>{transaction.waypointSymbol}</td>
                    <td>{transaction.shipSymbol}</td>
                    <td>{transaction.tradeSymbol}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        )}
        {tab == 'tradeGoods' && (
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>Purchase</th>
                  <th>Sell</th>
                  <th>Supply</th>
                  <th>Volume</th>
                  <th>In Cargo</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tradeGoods && tradeGoods.map((item, idx) => (
                  <tr key={idx} className={tradeGoodInContract(item.symbol, contracts) ? 'highlight' : undefined}>
                    <td>{item.symbol}</td>
                    <td><FontAwesomeIcon icon={faKipSign} /> {formatNumber(item.purchasePrice)}</td>
                    <td><FontAwesomeIcon icon={faKipSign} /> {formatNumber(item.sellPrice)}</td>
                    <td>{item.supply}</td>
                    <td>{formatNumber(item.tradeVolume)}</td>
                    <td>{getCargoUnits(cargo, item.symbol)}</td>
                    <td>
                      <ButtonGroup>
                        <TableActions>
                          <input type="number" placeholder="0" onChange={(e) => setAmount(e.target.value)} />
                          <Button $action="icon" onClick={() => purchase(item.symbol)}>
                            <FontAwesomeIcon size="lg" icon={faPlus} />
                          </Button>
                          {hasCargo(cargo, item.symbol) && 
                            <Button onClick={() => sell(item.symbol)} $action="icon">
                              <FontAwesomeIcon size="lg" icon={faMinus} />
                            </Button>
                          }
                        </TableActions>
                      </ButtonGroup>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        )}
      </Flow>
    </Modal>
  );
}

export default MarketplaceModal;
